import { Controller } from "@hotwired/stimulus";
import intlTelInput from "intl-tel-input";

// Connects to data-controller="phone"
export default class extends Controller {
  static values = {
    model: String,
  };

  static targets = ["input"];

  connect() {
    intlTelInput(this.inputTarget, {
      loadUtils: () => import("intl-tel-input/utils"),
      initialCountry: "auto",
      geoIpLookup: (success, failure) => {
        fetch("https://ipapi.co/json")
          .then((res) => res.json())
          .then((data) => success(data.country_code))
          .catch(() => failure());
      },
      hiddenInput: (telInputName) => {
        return {
          phone: telInputName,
          country: `${this.modelValue}[phone_country]`,
        };
      },
    });
  }
}
